interface EventsHeroProps {
  searchQuery: string;
  onSearchChange: (q: string) => void;
  onSubmitEvent: () => void;
}

export default function EventsHero({ searchQuery, onSearchChange, onSubmitEvent }: EventsHeroProps) {
  return (
    <section className="relative pt-28 pb-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/048ed6644b06fae7ea1557aa41b9eecc.jpg"
          alt="Events background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Location pill */}
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5">
          <i className="ri-map-pin-2-fill text-pink-300"></i>
          Sugar Hill &amp; Gwinnett County, Georgia
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Events &amp; <span className="text-pink-300">Happenings</span>
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-3">
          Festivals, pop-ups, weekend events, and community happenings — everything time-based in Sugar Hill, Gwinnett, and surrounding areas.
        </p>
        <p className="text-white/55 text-xs max-w-xl mx-auto mb-8">
          Looking for parks, indoor play, or things to do any time?{' '}
          <a href="/things-to-do" className="text-pink-300 font-semibold hover:text-pink-200 underline cursor-pointer">
            Visit Things To Do →
          </a>
        </p>

        {/* Search + Submit */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center max-w-lg mx-auto mb-10">
          <div className="relative flex-1 w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-base"></i>
            <input
              type="text"
              placeholder="Find something to do this week…"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-9 pr-4 py-2.5 rounded-full bg-white text-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-pink-400"
            />
          </div>
          <button
            onClick={onSubmitEvent}
            className="whitespace-nowrap px-5 py-2.5 bg-pink-500 hover:bg-pink-600 text-white text-sm font-semibold rounded-full transition-colors cursor-pointer flex items-center gap-2"
          >
            <i className="ri-add-circle-line"></i>
            Submit an Event
          </button>
        </div>

        {/* Section jump links */}
        <div className="flex flex-wrap justify-center gap-3">
          <a
            href="#our-events"
            className="flex items-center gap-2 px-5 py-2 bg-white text-gray-800 text-sm font-semibold rounded-full hover:bg-pink-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-2.5 h-2.5 rounded-full bg-pink-500 inline-block"></span>
            Our Events
          </a>
          <a
            href="#local-events"
            className="flex items-center gap-2 px-5 py-2 bg-white/20 text-white text-sm font-semibold rounded-full hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap border border-white/30"
          >
            <span className="w-2.5 h-2.5 rounded-full bg-white inline-block"></span>
            Local Events Around Town
          </a>
        </div>
      </div>
    </section>
  );
}
